import EnquiryForm from "../components/EnquiryForm";
import PageTitle from "../components/PageTitle";

export default function Enquiry() {
  return (
    <>
      <PageTitle title="Service Enquiry | Anara Lifethread" />
      <EnquiryForm />
    </>
  );
}